// extracted by mini-css-extract-plugin
export default {"moduleWrapper":"AboutServices_moduleWrapper__XoSlT","title":"AboutServices_title__X+HiM"};